import InherentRisksColumnList from './InherentRiskColumnList';
export default InherentRisksColumnList;
